// src/prints/PurchaseOrder_print.jsx
import React, { useEffect, useState } from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import { useParams } from "react-router-dom";
import axios from "axios";
import Logo from "../assets/logo.png";

const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";

const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

const PurchaseOrder_print = () => {
  useAuthRedirect();
  const { poNo } = useParams();
  const branch = localStorage.getItem("branch");

  const [poDetail, setPoDetail] = useState({});
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);

  const [subDetails, setSubDetails] = useState({});

  // ---- Site / Company info for header ----
  const [site, setSite] = useState({
    ok: true,
    name: "Infraconsoft",
    logo: null,
    address: "",
    email: "",
    phone: "",
    _ts: 0,
  });

  // Fetch site/company info
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}/siteinfo`);
        const s = res?.data || {};
        // ensure absolute logo URL if server ever returns relative
        let logo = s.logo || null;
        if (logo && !/^https?:\/\//i.test(logo)) {
          if (!logo.startsWith("/")) logo = `/${logo}`;
          logo = `${API_ORIGIN}${logo}`;
        }
        if (!ignore) {
          setSite({
            ok: !!s.ok,
            name: s.name || "Infraconsoft",
            logo,
            address: s.address || "",
            email: s.email || "",
            phone: s.phone || "",
            _ts: Date.now(),
          });
        }
      } catch (e) {
        // keep defaults on failure
        console.error("Failed to load /siteinfo", e);
      }
    })();
    return () => {
      ignore = true;
    };
  }, []);

  // Fetch PO header
  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(
          `${API_BASE}/purchaseOrder_detailsHeader?poNo=${poNo}`
        );
        if (response.data && response.data.headerDetails?.length > 0) {
          const items = response.data.headerDetails;

          const storeReqHeader = {
            purchaseOrderHeader_suppliercode: items[0].purchaseOrderHeader_suppliercode,
            purchaseOrderHeader_podate: items[0].purchaseOrderHeader_podate,
            purchaseOrderHeader_supplierName: items[0].purchaseOrderHeader_supplierName,
            purchaseOrderHeader_yourReferenceNumber:
              items[0].purchaseOrderHeader_yourReferenceNumber,
            purchaseOrderHeader_yourReferenceDate:
              items[0].purchaseOrderHeader_yourReferenceDate,
            purchaseOrderHeader_ourReferenceNumber:
              items[0].purchaseOrderHeader_ourReferenceNumber,
            purchaseOrderHeader_ourReferenceDate:
              items[0].purchaseOrderHeader_ourReferenceDate,
            purchaseOrderHeader_value: items[0].purchaseOrderHeader_value,
            purchaseOrderHeader_discount: items[0].purchaseOrderHeader_discount,
            purchaseOrderHeader_pfcharges: items[0].purchaseOrderHeader_pfcharges,
            purchaseOrderHeader_freightCharges:
              items[0].purchaseOrderHeader_freightCharges,
            purchaseOrderHeader_totalValue: items[0].purchaseOrderHeader_totalValue,
            PurchaseOrderHeader_Transport: items[0].PurchaseOrderHeader_Transport,
            purchaseOrderHeader_paymentTerms:
              items[0].purchaseOrderHeader_paymentTerms,
            purchaseOrderHeader_deliveryMethod:
              items[0].purchaseOrderHeader_deliveryMethod,
            purchaseOrderHeader_deliveryPlace:
              items[0].purchaseOrderHeader_deliveryPlace,
            PurchaseOrderHeader_PriceBasis: items[0].PurchaseOrderHeader_PriceBasis,
            purchaseOrderHeader_remarks: items[0].purchaseOrderHeader_remarks,
            purchaseOrderHeader_cstTax: items[0].purchaseOrderHeader_cstTax,
            branchCode: items[0].branchCode,
            userId: items[0].userId,
          };

          setPoDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching PO header:", error);
      }
    };

    fetchIndentDetails();
  }, [poNo]);

  // Fetch supplier details (depends on header supplier code)
  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        if (!poDetail.purchaseOrderHeader_suppliercode) return;
        const response = await axios.get(
          `${API_BASE}/purchaseOrder_supDetails?supplierCode=${poDetail.purchaseOrderHeader_suppliercode}`
        );
        const items = response.data.supDetails || [];
        if (items.length > 0) {
          setSubDetails({
            supplierMaster_addressline1: items[0].supplierMaster_addressline1,
            supplierMaster_addressline2: items[0].supplierMaster_addressline2,
            supplierMaster_city: items[0].supplierMaster_city,
            supplierMaster_pincode: items[0].supplierMaster_pincode,
          });
        } else {
          setSubDetails({});
        }
      } catch (error) {
        console.error("Error fetching supplier details:", error);
      }
    };

    fetchSupplierDetails();
  }, [poDetail.purchaseOrderHeader_suppliercode]);

  // Fetch bottom details (items)
  useEffect(() => {
    axios
      .get(`${API_BASE}/purchaseOrder_detailsBottom?branch=${branch}&poNo=${poNo}`)
      .then((response) => {
        if (response.data && response.data.headerDetails2) {
          setData(response.data.headerDetails2);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching bottom details:", error);
        setData([]);
      });
  }, [branch, poNo]);

  // Fetch schedule
  useEffect(() => {
    axios
      .get(`${API_BASE}/purchaseOrder_schedule?branchcode=${branch}&poNo=${poNo}`)
      .then((response) => {
        if (response.data) {
          setData1(response.data);
        } else {
          setData1([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching schedule:", error);
        setData1([]);
      });
  }, [branch, poNo]);

  const handlePrint = () => window.print();

  const logoSrc = site.logo ? `${site.logo}${site._ts ? `?v=${site._ts}` : ""}` : Logo;

  return (
    <div className="delivery-note-container">
      {/* Header Section (from /api/siteinfo with fallback) */}
      <div className="header">
        <div className="logo">
          <img src={logoSrc} alt={`${site.name} Logo`} />
        </div>
        <div className="company-info">
          <h2 style={{ textTransform: "uppercase" }}>{site.name || "Infraconsoft"}</h2>
          <p>
            {site.address && <span>{site.address}.<br /></span>}
            {site.phone && <span>Ph: {site.phone}</span>}
            {site.phone && site.email && <span> | </span>}
            {site.email && <strong>E-mail: {site.email}</strong>}
          </p>
        </div>
      </div>

      {/* Delivery Details */}
      <div className="delivery-details">
        <div className="left">
          <p>
            <strong>Supplier Code:</strong>{" "}
            {poDetail.purchaseOrderHeader_suppliercode}
          </p>
          <p>
            <strong>Supplier Name:</strong>{" "}
            {poDetail.purchaseOrderHeader_supplierName}
          </p>
          <p>
            <strong>Address 1:</strong> {subDetails.supplierMaster_addressline1}
          </p>
          <p>
            <strong>Address 2:</strong> {subDetails.supplierMaster_addressline2}
          </p>
          <p>
            <strong>City:</strong> {subDetails.supplierMaster_city}
          </p>
          <p>
            <strong>Pin code:</strong> {subDetails.supplierMaster_pincode}
          </p>
        </div>
        <div className="right">
          <p>
            <strong>Purchase Order No:</strong> {poNo}
          </p>
          <p>
            <strong>PO. Date:</strong>{" "}
            {poDetail.purchaseOrderHeader_podate
              ? new Date(poDetail.purchaseOrderHeader_podate).toLocaleDateString(
                  "en-GB"
                )
              : ""}
          </p>
          <p>
            <strong>Your Ref No:</strong>{" "}
            {poDetail.purchaseOrderHeader_yourReferenceNumber}
          </p>
          <p>
            <strong>Your Ref Date:</strong>{" "}
            {poDetail.purchaseOrderHeader_yourReferenceDate
              ? new Date(
                  poDetail.purchaseOrderHeader_yourReferenceDate
                ).toLocaleDateString("en-GB")
              : ""}
          </p>
          <p>
            <strong>Our Ref No:</strong>{" "}
            {poDetail.purchaseOrderHeader_ourReferenceNumber}
          </p>
          <p>
            <strong>Our Ref Date:</strong>{" "}
            {poDetail.purchaseOrderHeader_ourReferenceDate
              ? new Date(
                  poDetail.purchaseOrderHeader_ourReferenceDate
                ).toLocaleDateString("en-GB")
              : ""}
          </p>
          <p>
            <strong>Branch:</strong> {poDetail.branchCode}
          </p>
          <p>
            <strong>Prepared By:</strong> {poDetail.userId}
          </p>
        </div>
      </div>

      {/* Items Table */}
      <table className="items-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Item</th>
            <th>Part No</th>
            <th>Description</th>
            <th>Qty</th>
            <th>Uom</th>
            <th>Price</th>
            <th>GST%</th>
            <th>PF%</th>
            <th>Disc%</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item?.purchaseOrderDetail_itemCode}</td>
                <td>{item?.itemmaster_drawingNumber}</td>
                <td>{item?.itemmaster_name}</td>
                <td>{item?.purchaseOrderDetail_orderedQuantity || 0}</td>
                <td>{item?.itemMaster_purchaseUom || 0}</td>
                <td>{item?.purchaseOrderDetail_price || 0}</td>
                <td>{item?.purchaseOrderDetail_cstTax}</td>
                <td>{item?.purchaseOrderDetail_PFpercentage}</td>
                <td>{item?.purchaseOrderDetail_discountPercentage}</td>
                <td>{item?.purchaseOrderDetail_value}</td>
              </tr>
            ))
          ) : (
            <tr>
              {/* 11 columns */}
              <td colSpan="11" style={{ textAlign: "center" }}>
                No items found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <h2>Schedule Details</h2>
      {/* Schedule Table */}
      <table className="items-table">
        <thead>
          <tr>
            <th>Schedule No</th>
            <th>Item Code</th>
            <th>Schedule Date</th>
            <th>Schedule Quantity</th>
          </tr>
        </thead>
        <tbody>
          {data1.length > 0 ? (
            data1.map((item, index) => (
              <tr key={index}>
                <td>{item?.PurchaseOrderSchedule_SerialNumber}</td>
                <td>{item?.PurchaseOrderSchedule_ItemCode}</td>
                <td>
                  {item?.PurchaseOrderSchedule_Date
                    ? new Date(item.PurchaseOrderSchedule_Date).toLocaleDateString(
                        "en-GB"
                      )
                    : ""}
                </td>
                <td>{item?.PurchaseOrderSchedule_Quantity}</td>
              </tr>
            ))
          ) : (
            <tr>
              {/* 4 columns */}
              <td colSpan="4" style={{ textAlign: "center" }}>
                No items found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <h2>Bill Details</h2>
      <table className="items-table">
        <tbody>
          <tr>
            <td>Sub Total</td>
            <td>₹{(poDetail.purchaseOrderHeader_value ?? 0).toFixed(2)}</td>
          </tr>
          <tr>
            <td>GST (18%)</td>
            <td>₹{(poDetail.purchaseOrderHeader_cstTax ?? 0).toFixed(2)}</td>
          </tr>
          <tr>
            <td>Disc (%)</td>
            <td>₹{(poDetail.purchaseOrderHeader_discount ?? 0).toFixed(2)}</td>
          </tr>
          <tr>
            <td>PF</td>
            <td>₹{(poDetail.purchaseOrderHeader_pfcharges ?? 0).toFixed(2)}</td>
          </tr>
          <tr>
            <td>Fright Charges</td>
            <td>
              ₹{(poDetail.purchaseOrderHeader_freightCharges ?? 0).toFixed(2)}
            </td>
          </tr>
          <tr>
            <td>Transport</td>
            <td>{poDetail.PurchaseOrderHeader_Transport}</td>
          </tr>
          <tr>
            <td>Payment Terms</td>
            <td>{poDetail.purchaseOrderHeader_paymentTerms}</td>
          </tr>
          <tr>
            <td>Delivery Method</td>
            <td>{poDetail.purchaseOrderHeader_deliveryMethod}</td>
          </tr>
          <tr>
            <td>Delivery Place</td>
            <td>{poDetail.purchaseOrderHeader_deliveryPlace}</td>
          </tr>
          <tr>
            <td>Price Basis</td>
            <td>{poDetail.PurchaseOrderHeader_PriceBasis}</td>
          </tr>
          <tr>
            <td>Remarks</td>
            <td>{poDetail.purchaseOrderHeader_remarks}</td>
          </tr>
          <tr>
            <td>Total</td>
            <td>₹{(poDetail.purchaseOrderHeader_totalValue ?? 0).toFixed(2)}</td>
          </tr>
        </tbody>
      </table>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button
          onClick={handlePrint}
          style={{
            backgroundColor: "#4a90e2",
            color: "white",
            border: "none",
            padding: "12px 24px",
            fontSize: "16px",
            cursor: "pointer",
            borderRadius: "8px",
            transition: "background 0.3s ease-in-out",
            marginTop: "20px",
          }}
        >
          Print
        </button>
      </div>
    </div>
  );
};

export default PurchaseOrder_print;
